"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportFileRequest = void 0;
var destination_1 = require("../job/destination");
var callback_1 = require("../job/callback");
var external_authorization_1 = require("./external-authorization");
/**
 * Import File Request
 * @doc ImportFileRequest
 */
var ImportFileRequest = /** @class */ (function () {
    function ImportFileRequest(data) {
        this.sourceUrl = null;
        this.externalAuthorization = null;
        this.sourceUrl = data.sourceUrl;
        this.externalAuthorization = data.externalAuthorization
            ? new external_authorization_1.ExternalAuthorization(data.externalAuthorization)
            : null;
        this.destination = new destination_1.Destination(data.destination);
        if (data.jobCallback) {
            this.jobCallback = new callback_1.Callback(data.jobCallback);
        }
    }
    return ImportFileRequest;
}());
exports.ImportFileRequest = ImportFileRequest;
//# sourceMappingURL=import-file-request.js.map